var _excluded = ["day", "dateFormat", "locale", "onClick"];
import _JSXStyle from "styled-jsx/style";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import classnames from 'classnames';
import format from 'date-fns/format';
import isToday from 'date-fns/is_today';
import React from 'react';

var Day = function Day(_ref) {
  var day = _ref.day,
      dateFormat = _ref.dateFormat,
      locale = _ref.locale,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, _excluded);

  var disabled = !day.enabled;
  var classNames = classnames('text-center', {
    'bg-light text-muted': !day.sameMonth
  }, // Lighten days in months before & after
  {
    'bg-primary text-white': day.selected
  }, // Highlight selected date
  {
    'text-primary fw-bold': !day.selected && isToday(day.date)
  }, // Highlight today's date
  {
    invisible: !day.visible
  } // If date is (optionally) filtered out
  );
  var styles = disabled ? {
    cursor: 'not-allowed'
  } : {};
  var dayString = format(day.date, dateFormat, {
    locale: locale
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("td", _extends({
      onClick: disabled ? undefined : onClick // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
      ,
      role: "button",
      style: styles
    }, props, {
      className: "jsx-2353834249" + " " + (props && props.className != null && props.className || classNames || "")
    }), disabled ? /*#__PURE__*/React.createElement("s", {
      className: "jsx-2353834249"
    }, dayString) : dayString, /*#__PURE__*/React.createElement(_JSXStyle, {
      id: "2353834249"
    }, "td.jsx-2353834249:hover{font-weight:bold;}"))
  );
};

Day.displayName = "Day";
export default Day;